const DEFAULT_STEPS = [1, 2, 5, 10, 15, 20, 25, 50, 100];

/**
 * Computes the X-axis value range for Recharts' `<XAxis domain={[0, domainMax]} />`
 * ("domain" = the span of data values the axis covers, e.g. 0–25%).
 *
 * `domainMax` is the smallest readable step >= `rawMax` (the largest row value),
 * and `ticks` are the labelled grid marks (excluding 0).
 */
export const getDomainAndTicks = (rawMax: number, explicitTicks?: number[]): { domainMax: number; ticks: number[] } => {
  const safeMax = Number.isFinite(rawMax) && rawMax > 0 ? rawMax : 1;

  // Ignore invalid ticks (NaN, Infinity, <= 0); fall back to generated ticks when none remain
  const validTicks = [...new Set(explicitTicks?.filter(tick => Number.isFinite(tick) && tick > 0))].sort(
    (a, b) => a - b
  );
  if (validTicks.length) {
    return { domainMax: Math.max(...validTicks, safeMax), ticks: validTicks };
  }

  const domainMax = DEFAULT_STEPS.find(step => step >= safeMax) ?? Math.ceil(safeMax);

  const half = domainMax / 2;
  const midTick = [...DEFAULT_STEPS].reverse().find(step => step <= half && step < domainMax);

  return {
    domainMax,
    ticks: midTick != null ? [midTick, domainMax] : [domainMax],
  };
};
